(() => {

  const root =
    document.querySelector(
      '[data-pnmd-dashboard]'
    );

  if (!root) {
    return;
  }


  const loading =
    root.querySelector(
      '[data-pnmd-loading]'
    );

  const onboarding =
    root.querySelector(
      '[data-pnmd-onboarding]'
    );

  const workspace =
    root.querySelector(
      '[data-pnmd-workspace]'
    );

  const form =
    root.querySelector(
      '[data-pnmd-form]'
    );

  const message =
    root.querySelector(
      '[data-pnmd-message]'
    );

  const submit =
    root.querySelector(
      '[data-pnmd-submit]'
    );

  const photoInput =
    root.querySelector(
      '[data-pnmd-photo]'
    );

  const photoPreview =
    root.querySelector(
      '[data-pnmd-photo-preview]'
    );

  const expertiseContainer =
    root.querySelector(
      '[data-pnmd-expertise]'
    );

  const languagesContainer =
    root.querySelector(
      '[data-pnmd-languages]'
    );


  let initialized = false;
  let mentorProfile = null;
  let photoURL = null;


  function escapeHTML(
    value
  ) {

    return String(
      value ?? ''
    )
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  }


  function showOnly(
    target
  ) {

    loading.hidden =
      target !== loading;

    onboarding.hidden =
      target !== onboarding;

    workspace.hidden =
      target !== workspace;

  }


  function showMessage(
    text,
    type = 'error'
  ) {

    message.textContent =
      text;

    message.dataset.type =
      type;

    message.hidden =
      false;

  }


  function clearMessage() {

    message.hidden =
      true;

    message.textContent =
      '';

    delete message.dataset.type;

  }


  function selectedValues(
    selector
  ) {

    return [
      ...root.querySelectorAll(
        `${selector}:checked`
      )
    ].map(
      input =>
        input.value
    );

  }


  function lines(
    value
  ) {

    return String(
      value || ''
    )
      .split(/\r?\n/)
      .map(
        item =>
          item.trim()
      )
      .filter(Boolean);

  }


  function renderChoices(
    container,
    rows,
    name,
    max
  ) {

    if (!rows.length) {

      container.innerHTML = `
        <div class="pnmd-choice-empty">
          No options are available yet.
        </div>
      `;

      return;
    }


    container.innerHTML =
      rows
        .map(
          row => `
            <label class="pnmd-choice">

              <input
                type="checkbox"
                name="${escapeHTML(name)}"
                value="${escapeHTML(row.id)}"
                data-max="${max}"
                data-choice-other="${
                  String(
                    (
                      row.slug ||
                      row.name ||
                      ''
                    ).toLowerCase() ===
                    'other'
                  )
                }"
              >

              <span>
                ${escapeHTML(row.name)}
              </span>

            </label>
          `
        )
        .join('');


    container
      .querySelectorAll(
        'input[type="checkbox"]'
      )
      .forEach(
        input => {

          input.addEventListener(
            'change',
            () => {

              const checked =
                [
                  ...container
                    .querySelectorAll(
                      'input:checked'
                    )
                ];


              if (
                checked.length >
                max
              ) {

                input.checked =
                  false;


                showMessage(
                  `You can select up to ${max}.`
                );

              }

              else {

                clearMessage();

              }


              syncOtherFields();

            }
          );

        }
      );

  }


  function syncOtherFields() {

    const expertiseOther =
      expertiseContainer
        .querySelector(
          'input[data-choice-other="true"]'
        );


    const languageOther =
      languagesContainer
        .querySelector(
          'input[data-choice-other="true"]'
        );


    const expertiseWrap =
      root.querySelector(
        '[data-pnmd-custom-expertise-wrap]'
      );


    const languageWrap =
      root.querySelector(
        '[data-pnmd-custom-language-wrap]'
      );


    const expertiseInput =
      form.elements
        .custom_expertise_text;


    const languageInput =
      form.elements
        .custom_language_text;


    const expertiseSelected =
      Boolean(
        expertiseOther?.checked
      );


    const languageSelected =
      Boolean(
        languageOther?.checked
      );


    if (
      expertiseWrap &&
      expertiseInput
    ) {

      expertiseWrap.hidden =
        !expertiseSelected;

      expertiseInput.required =
        expertiseSelected;


      if (!expertiseSelected) {
        expertiseInput.value = '';
      }

    }


    if (
      languageWrap &&
      languageInput
    ) {

      languageWrap.hidden =
        !languageSelected;

      languageInput.required =
        languageSelected;


      if (!languageSelected) {
        languageInput.value = '';
      }

    }

  }



  function populateForm(
    profile,
    accountProfile
  ) {

    form.elements
      .display_name
      .value =
        profile.display_name ||
        accountProfile?.full_name ||
        '';


    form.elements
      .bio
      .value =
        profile.bio ||
        '';


    form.elements
      .graduation_year
      .value =
        profile.graduation_year ||
        '';


    form.elements
      .linkedin_url
      .value =
        profile.linkedin_url ||
        '';


    if (form.elements.location_text) {

      form.elements
        .location_text
        .value =
          profile.location_text ||
          '';

    }


    root.querySelector(
      '[data-pnmd-college]'
    ).value =
      profile.college_name_text ||
      '';


    root.querySelector(
      '[data-pnmd-program]'
    ).value =
      profile.program_name_text ||
      '';


    if (
      profile.photo_url
    ) {

      photoURL =
        profile.photo_url;


      photoPreview.innerHTML = `
        <img
          src="${escapeHTML(
            profile.photo_url
          )}"
          alt=""
        >
      `;

    }

  }


  function renderWorkspace(
    profile
  ) {

    const photo =
      root.querySelector(
        '[data-pnmd-workspace-photo]'
      );


    if (
      profile.photo_url
    ) {

      photo.innerHTML = `
        <img
          src="${escapeHTML(
            profile.photo_url
          )}"
          alt=""
        >
      `;

    }


    root.querySelector(
      '[data-pnmd-workspace-name]'
    ).textContent =
      profile.display_name ||
      'PeerNest Mentor';


    root.querySelector(
      '[data-pnmd-workspace-college]'
    ).textContent =
      profile.college_name_text ||
      'College';


    root.querySelector(
      '[data-pnmd-workspace-program]'
    ).textContent =
      profile.program_name_text ||
      'Program';


    root.querySelector(
      '[data-pnmd-sessions]'
    ).textContent =
      profile.sessions_completed ??
      0;


    root.querySelector(
      '[data-pnmd-rating]'
    ).textContent =
      Number(
        profile.review_count || 0
      ) > 0
        ? Number(
            profile.rating || 0
          ).toFixed(1)
        : '—';


    const visible =
      profile.is_visible ===
      true;


    root.querySelector(
      '[data-pnmd-visibility]'
    ).textContent =
      visible
        ? '● Public profile'
        : 'Profile hidden';


    root.querySelector(
      '[data-pnmd-public-state]'
    ).textContent =
      visible
        ? 'Live'
        : 'Hidden';


    showOnly(
      workspace
    );

    // Keep visibility independent from availability retrieval.
    syncMentorVisibilityUI([]);

  }


  async function handleSubmit(
    event
  ) {

    event.preventDefault();

    clearMessage();


    if (
      !form.reportValidity()
    ) {
      return;
    }


    const expertise =
      selectedValues(
        'input[name="expertise_ids"]'
      );


    const languages =
      selectedValues(
        'input[name="language_ids"]'
      );


    const customExpertise =
      String(
        form.elements
          .custom_expertise_text
          ?.value || ''
      ).trim();


    const customLanguage =
      String(
        form.elements
          .custom_language_text
          ?.value || ''
      ).trim();


    const otherExpertiseSelected =
      Boolean(
        expertiseContainer
          .querySelector(
            'input[data-choice-other="true"]:checked'
          )
      );


    const otherLanguageSelected =
      Boolean(
        languagesContainer
          .querySelector(
            'input[data-choice-other="true"]:checked'
          )
      );


    if (!expertise.length) {

      showMessage(
        'Select at least one expertise area.'
      );

      return;

    }


    if (!languages.length) {

      showMessage(
        'Select at least one language.'
      );

      return;

    }


    if (
      otherExpertiseSelected &&
      !customExpertise
    ) {

      showMessage(
        'Enter your other expertise area.'
      );

      form.elements
        .custom_expertise_text
        ?.focus();

      return;

    }


    if (
      otherLanguageSelected &&
      !customLanguage
    ) {

      showMessage(
        'Enter your other language.'
      );

      form.elements
        .custom_language_text
        ?.focus();

      return;

    }


    try {

      submit.disabled =
        true;

      submit.textContent =
        'Saving mentor profile…';


      const newPhoto =
        photoInput.files?.[0];


      if (newPhoto) {

        submit.textContent =
          'Uploading profile photo…';


        photoURL =
          await window.PeerNestDB
            .uploadMyMentorPhoto(
              newPhoto
            );

      }


      if (!photoURL) {

        throw new Error(
          'Add a public mentor photo.'
        );

      }


      submit.textContent =
        'Completing setup…';


      const result =
        await window.PeerNestDB
          .completeMyMentorOnboarding({

            display_name:
              form.elements
                .display_name
                .value,

            bio:
              form.elements
                .bio
                .value,

            graduation_year:
              form.elements
                .graduation_year
                .value,

            linkedin_url:
              form.elements
                .linkedin_url
                .value,

            photo_url:
              photoURL,

            expertise_ids:
              expertise,

            language_ids:
              languages,

            custom_expertise_text:
              customExpertise,

            custom_language_text:
              customLanguage,

            achievements:
              lines(
                form.elements
                  .achievements
                  .value
              ),

            default_meet_url:
              form.elements
                .default_meet_url
                .value,

            location_text:
              form.elements
                .location_text
                .value

          });


      if (
        !result?.id ||
        result.onboarding_completed !==
          true
      ) {

        throw new Error(
          'Mentor onboarding was not completed.'
        );

      }


      mentorProfile =
        result;


      renderWorkspace(
        mentorProfile
      );


      await loadAvailability();

    }

    catch (error) {

      console.error(
        '[PeerNest] Mentor onboarding:',
        error
      );


      showMessage(
        error?.message ||
        'We could not complete your mentor setup.'
      );


      submit.disabled =
        false;

      submit.textContent =
        'Complete mentor setup →';

    }

  }


  function availabilityMessage(
    message = '',
    isError = false
  ) {

    const element =
      root.querySelector(
        '[data-pnmd-availability-message]'
      );


    if (!element) {
      return;
    }


    element.textContent =
      message;


    element.dataset.state =
      isError
        ? 'error'
        : 'success';

  }



  function formatAvailabilityDate(
    value
  ) {

    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }


    return new Intl.DateTimeFormat(
      undefined,
      {
        weekday:'short',
        day:'numeric',
        month:'short',
        hour:'numeric',
        minute:'2-digit'
      }
    ).format(date);

  }



  function formatAvailabilityTime(
    value
  ) {

    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }


    return new Intl.DateTimeFormat(
      undefined,
      {
        hour:'numeric',
        minute:'2-digit'
      }
    ).format(date);

  }



  async function loadAvailability() {

    const list =
      root.querySelector(
        '[data-pnmd-availability-list]'
      );


    if (!list) {
      return;
    }


    list.innerHTML = `
      <p class="pnmd-muted">
        Loading availability…
      </p>
    `;


    try {

      const blocks =
        await window.PeerNestDB
          .getMyMentorAvailability();


      syncMentorVisibilityUI(
        blocks
      );


      if (
        !Array.isArray(blocks) ||
        !blocks.length
      ) {

        list.innerHTML = `
          <div class="pnmd-availability__empty">
            <strong>
              No upcoming availability yet.
            </strong>

            <p>
              Add your first time block above.
              PeerNest will generate the individual
              session slots automatically.
            </p>
          </div>
        `;

        return;

      }


      list.innerHTML =
        blocks
          .map(
            block => {

              const slots =
                Array.isArray(block.slots)
                  ? block.slots
                  : [];


              const availableSlots =
                slots.filter(
                  slot =>
                    slot.status ===
                    'available'
                );


              const slotMarkup =
                availableSlots.length
                  ? availableSlots
                      .map(
                        slot => `
                          <button
                            type="button"
                            class="pnmd-slot-chip"
                            data-pnmd-remove-slot="${escapeHTML(
                              slot.id
                            )}"
                            title="Remove this 15-minute slot"
                          >
                            <span>
                              ${escapeHTML(
                                formatAvailabilityTime(
                                  slot.starts_at
                                )
                              )}
                            </span>

                            <span
                              class="pnmd-slot-chip__remove"
                              aria-hidden="true"
                            >
                              ×
                            </span>
                          </button>
                        `
                      )
                      .join('')
                  : `
                    <span class="pnmd-muted">
                      No available slots.
                    </span>
                  `;


              return `
                <article
                  class="pnmd-availability-block"
                  data-pnmd-availability-block="${escapeHTML(
                    block.id
                  )}"
                >

                  <div class="pnmd-availability-block__head">

                    <div>
                      <strong>
                        ${escapeHTML(
                          formatAvailabilityDate(
                            block.starts_at
                          )
                        )}
                      </strong>

                      <span>
                        ${availableSlots.length}
                        available
                        ${availableSlots.length === 1
                          ? 'slot'
                          : 'slots'}
                        ·
                        Quick 15 / Deep Dive 30
                      </span>
                    </div>




                  </div>


                  <div class="pnmd-slot-list">
                    ${slotMarkup}
                  </div>

                </article>
              `;

            }
          )
          .join('');

    }

    catch (error) {

      console.error(
        '[PeerNest] Availability:',
        error
      );

      // Keep the existing live mentor's Hide profile control accessible.
      syncMentorVisibilityUI([]);

      list.innerHTML = `
        <div class="pnmd-availability__empty">
          <strong>
            Availability couldn't be loaded.
          </strong>

          <p>
            ${escapeHTML(
              error?.message ||
              'Please try again.'
            )}
          </p>
        </div>
      `;

    }

  }



  async function openAvailability() {

    const section =
      root.querySelector(
        '[data-pnmd-availability]'
      );


    const nav =
      root.querySelector(
        '[data-pnmd-availability-nav]'
      );


    if (!section) {
      return;
    }


    section.hidden =
      false;


    root
      .querySelectorAll(
        '.pnmd-sidebar button'
      )
      .forEach(
        button =>
          button.classList.remove(
            'is-active'
          )
      );


    nav?.classList.add(
      'is-active'
    );
await loadAvailability();


    section.scrollIntoView({
      behavior:'smooth',
      block:'start'
    });

  }



  async function handleAvailabilitySubmit(
    event
  ) {

    event.preventDefault();


    const availabilityForm =
      event.currentTarget;


    if (
      !availabilityForm.reportValidity()
    ) {
      return;
    }


    const startsValue =
      availabilityForm.elements
        .availability_starts_at
        .value;


    const endsValue =
      availabilityForm.elements
        .availability_ends_at
        .value;


    const starts =
      new Date(startsValue);


    const ends =
      new Date(endsValue);


    if (
      Number.isNaN(starts.getTime()) ||
      Number.isNaN(ends.getTime())
    ) {

      availabilityMessage(
        'Choose a valid start and end time.',
        true
      );

      return;

    }


    if (
      starts.getTime() <=
      Date.now()
    ) {

      availabilityMessage(
        'Availability must start in the future.',
        true
      );

      return;

    }


    if (
      ends <= starts
    ) {

      availabilityMessage(
        'End time must be after the start time.',
        true
      );

      return;

    }


    const button =
      root.querySelector(
        '[data-pnmd-availability-submit]'
      );


    try {

      button.disabled =
        true;

      button.textContent =
        'Creating slots…';


      availabilityMessage(
        ''
      );


      const timezone =
        Intl.DateTimeFormat()
          .resolvedOptions()
          .timeZone ||
        'Asia/Kolkata';


      const result =
        await window.PeerNestDB
          .createMyAvailabilityBlock({

            starts_at:
              starts.toISOString(),

            ends_at:
              ends.toISOString(),

            timezone

          });


      if (!result?.block_id) {

        throw new Error(
          'Availability could not be created.'
        );

      }


      availabilityMessage(
        `${result.slots_created || 0} session slots created.`
      );


      availabilityForm.reset();


      await loadAvailability();

    }

    catch (error) {

      console.error(
        '[PeerNest] Create availability:',
        error
      );


      availabilityMessage(
        error?.message ||
        'Availability could not be created.',
        true
      );

    }

    finally {

      button.disabled =
        false;

      button.textContent =
        'Add availability →';

    }

  }



  async function handleAvailabilityListClick(
    event
  ) {

    const slotButton =
      event.target.closest(
        '[data-pnmd-remove-slot]'
      );


    if (slotButton) {

      const slotId =
        slotButton.dataset
          .pnmdRemoveSlot;


      if (!slotId) {
        return;
      }


      try {

        slotButton.disabled =
          true;


        await window.PeerNestDB
          .removeMyAvailabilitySlot(
            slotId
          );


        availabilityMessage(
          'That 15-minute slot was removed.'
        );


        await loadAvailability();

      }

      catch (error) {

        console.error(
          '[PeerNest] Remove availability slot:',
          error
        );


        availabilityMessage(
          error?.message ||
          'That slot could not be removed.',
          true
        );


        slotButton.disabled =
          false;

      }


      return;

    }


    /*
     * Legacy whole-block support remains available
     * internally, but it is no longer the normal UI action.
     */

    const blockButton =
      event.target.closest(
        '[data-pnmd-remove-availability]'
      );


    if (!blockButton) {
      return;
    }


    const blockId =
      blockButton.dataset
        .pnmdRemoveAvailability;


    if (!blockId) {
      return;
    }


    try {

      blockButton.disabled =
        true;


      await window.PeerNestDB
        .removeMyAvailabilityBlock(
          blockId
        );


      availabilityMessage(
        'Availability block removed.'
      );


      await loadAvailability();

    }

    catch (error) {

      console.error(
        '[PeerNest] Remove availability block:',
        error
      );


      availabilityMessage(
        error?.message ||
        'Availability could not be removed.',
        true
      );


      blockButton.disabled =
        false;

    }

  }



  function syncMentorVisibilityUI(
    blocks = []
  ) {

    const availabilityButton =
      root.querySelector(
        '[data-pnmd-availability-cta]'
      );


    const visibilityButton =
      root.querySelector(
        '[data-pnmd-visibility-cta]'
      );


    const title =
      root.querySelector(
        '[data-pnmd-next-title]'
      );


    const copy =
      root.querySelector(
        '[data-pnmd-next-copy]'
      );


    const publicState =
      root.querySelector(
        '[data-pnmd-public-state]'
      );


    const now =
      Date.now();


    const hasFutureAvailability =
      blocks.some(
        block =>
          block?.is_active !== false &&
          Array.isArray(block?.slots) &&
          block.slots.some(
            slot =>
              slot?.status === 'available' &&
              new Date(
                slot.starts_at
              ).getTime() > now
          )
      );


    const isLive =
      mentorProfile?.is_visible === true;


    if (publicState) {
      publicState.textContent =
        isLive
          ? 'Live'
          : 'Hidden';
    }


    if (isLive) {

      if (title) {
        title.textContent =
          'Your mentor profile is live.';
      }

      if (copy) {
        copy.textContent =
          'Students can discover your profile and book from your available times.';
      }

      if (availabilityButton) {
        availabilityButton.hidden =
          false;

        availabilityButton.textContent =
          'Manage availability →';
      }

      if (visibilityButton) {
        visibilityButton.hidden =
          false;

        visibilityButton.textContent =
          'Hide profile';
      }

      return;

    }


    if (hasFutureAvailability) {

      if (title) {
        title.textContent =
          "You're ready to go live.";
      }

      if (copy) {
        copy.textContent =
          'Your availability is set. Publish your profile so students can discover you.';
      }

      if (availabilityButton) {
        availabilityButton.hidden =
          false;

        availabilityButton.textContent =
          'Manage availability →';
      }

      if (visibilityButton) {
        visibilityButton.hidden =
          false;

        visibilityButton.textContent =
          'Go Live →';
      }

      return;

    }


    if (title) {
      title.textContent =
        'Set your availability.';
    }

    if (copy) {
      copy.textContent =
        "Your profile is complete, but students can't discover or book you until you add availability.";
    }

    if (availabilityButton) {
      availabilityButton.hidden =
        false;

      availabilityButton.textContent =
        'Set availability →';
    }

    if (visibilityButton) {
      visibilityButton.hidden =
        true;
    }

  }



  async function handleVisibilityToggle() {

    const button =
      root.querySelector(
        '[data-pnmd-visibility-cta]'
      );


    if (!button) {
      return;
    }


    const shouldGoLive =
      mentorProfile?.is_visible !== true;


    try {

      button.disabled =
        true;

      button.textContent =
        shouldGoLive
          ? 'Publishing…'
          : 'Hiding…';


      const result =
        await window.PeerNestDB
          .setMyMentorVisibility(
            shouldGoLive
          );


      if (!result?.id) {
        throw new Error(
          'Profile visibility could not be updated.'
        );
      }


      mentorProfile =
        result;

      // Update visibility as soon as the mutation succeeds, even if slots time out.
      const visibilityStatus = root.querySelector('[data-pnmd-visibility]');
      if (visibilityStatus) {
        visibilityStatus.textContent = result.is_visible === true
          ? '● Public profile'
          : 'Profile hidden';
      }
      syncMentorVisibilityUI([]);

      await loadAvailability();

    }

    catch (error) {

      console.error(
        '[PeerNest] Mentor visibility:',
        error
      );


      availabilityMessage(
        error?.message ||
        'Profile visibility could not be updated.',
        true
      );

    }

    finally {

      button.disabled =
        false;

    }

  }



  async function init(
    event
  ) {

    if (initialized) {
      return;
    }


    const profile =
      event?.detail?.profile;


    if (
      profile &&
      profile.role !== 'mentor'
    ) {
      return;
    }


    initialized =
      true;


    try {

      const [
        mentor,
        accountProfile,
        expertise,
        languages
      ] =
        await Promise.all([

          window.PeerNestDB
            .getMyMentorProfile(),

          window.PeerNestDB
            .getMyProfile(),

          window.PeerNestDB
            .getExpertiseTags(),

          window.PeerNestDB
            .getLanguages()

        ]);


      if (!mentor?.id) {

        throw new Error(
          'Approved mentor profile not found.'
        );

      }


      mentorProfile =
        mentor;


      if (
        mentor.onboarding_completed ===
        true
      ) {

        renderWorkspace(
          mentor
        );

        await loadAvailability();

        return;

      }


      renderChoices(
        expertiseContainer,
        expertise,
        'expertise_ids',
        5
      );


      renderChoices(
        languagesContainer,
        languages,
        'language_ids',
        6
      );


      syncOtherFields();


      populateForm(
        mentor,
        accountProfile
      );

      // PN_MENTOR_CHOICES_FULLWIDTH_V1: initial onboarding only.
      // Uses the owner's application as suggestions, never overwrites saved values.
      try {
        await window.PeerNestMentorAppPrefill?.apply?.({
          form, expertiseContainer, languagesContainer, mentor
        });
      } catch (error) {
        console.warn('[PeerNest] Application prefill unavailable:', error);
      }


      showOnly(
        onboarding
      );

    }

    catch (error) {

      console.error(
        '[PeerNest] Mentor dashboard:',
        error
      );


      loading.innerHTML = `
        <div class="pnmd-error">
          <strong>
            Mentor workspace couldn't be opened.
          </strong>

          <p>
            ${escapeHTML(
              error?.message ||
              'Please try again.'
            )}
          </p>
        </div>
      `;

    }

  }


  photoInput.addEventListener(
    'change',
    () => {

      const file =
        photoInput.files?.[0];


      if (!file) {
        return;
      }


      const preview =
        URL.createObjectURL(
          file
        );


      photoPreview.innerHTML = `
        <img
          src="${escapeHTML(preview)}"
          alt=""
        >
      `;

    }
  );


  root
    .querySelector(
      '[data-pnmd-availability-cta]'
    )
    ?.addEventListener(
      'click',
      openAvailability
    );


  root
    .querySelector(
      '[data-pnmd-availability-nav]'
    )
    ?.addEventListener(
      'click',
      openAvailability
    );


  root
    .querySelector(
      '[data-pnmd-availability-form]'
    )
    ?.addEventListener(
      'submit',
      handleAvailabilitySubmit
    );


  root
    .querySelector(
      '[data-pnmd-availability-list]'
    )
    ?.addEventListener(
      'click',
      handleAvailabilityListClick
    );


  root
    .querySelector(
      '[data-pnmd-visibility-cta]'
    )
    ?.addEventListener(
      'click',
      handleVisibilityToggle
    );


  form.addEventListener(
    'submit',
    handleSubmit
  );


  document.addEventListener(
    'peernest:dashboard-ready',
    init
  );


  const content =
    root.querySelector(
      '[data-pndash-content]'
    );


  if (
    content &&
    !content.hidden &&
    window.PeerNestDB
  ) {

    init();

  }

})();

/* MENTOR WORKSPACE SWITCHER START */

(function () {

  function initMentorWorkspaceSwitcher() {

    const root =
      document.querySelector(
        '[data-pnmd-dashboard]'
      );

    if (!root) {
      return;
    }


    const workspace =
      root.querySelector(
        '[data-pnmd-workspace]'
      );

    if (!workspace) {
      return;
    }


    const links =
      Array.from(
        workspace.querySelectorAll(
          '[data-pnmd-view-link]'
        )
      );


    const views =
      Array.from(
        workspace.querySelectorAll(
          '[data-pnmd-view]'
        )
      );


    if (!links.length || !views.length) {
      return;
    }


    const allowed =
      new Set(
        views.map(
          view =>
            view.dataset.pnmdView
        )
      );


    function mirrorText(
      sourceSelector,
      targetSelector
    ) {

      const source =
        root.querySelector(
          sourceSelector
        );

      const targets =
        root.querySelectorAll(
          targetSelector
        );


      if (!source || !targets.length) {
        return;
      }


      targets.forEach(
        target => {
          target.textContent =
            source.textContent.trim();
        }
      );

    }


    function syncRealData() {

      mirrorText(
        '[data-pnmd-sessions]',
        '[data-pnmd-view-sessions-count]'
      );

      mirrorText(
        '[data-pnmd-rating]',
        '[data-pnmd-view-rating]'
      );

      mirrorText(
        '[data-pnmd-public-state]',
        '[data-pnmd-view-public-state]'
      );

    }


    function showView(
      name,
      updateHash = true,
      scroll = true
    ) {

      if (!allowed.has(name)) {
        name = 'overview';
      }


      root.dataset.pnmdActiveView =
        name;


      views.forEach(
        view => {

          const active =
            view.dataset.pnmdView ===
            name;

          view.hidden =
            !active;

          view.classList.toggle(
            'is-active',
            active
          );

        }
      );


      links.forEach(
        link => {

          const active =
            link.dataset.pnmdViewLink ===
            name;

          link.classList.toggle(
            'is-active',
            active
          );


          if (active) {

            link.setAttribute(
              'aria-current',
              'page'
            );

          }
          else {

            link.removeAttribute(
              'aria-current'
            );

          }

        }
      );


      if (name === 'availability') {

        const availability =
          root.querySelector(
            '[data-pnmd-availability]'
          );

        if (availability) {
          availability.hidden = false;
        }

      }


      syncRealData();


      if (updateHash) {

        history.replaceState(
          null,
          '',
          '#mentor-' + name
        );

      }


      if (scroll) {

        const main =
          workspace.querySelector(
            '.pnmd-workspace__main'
          );

        if (main) {

          const top =
            main.getBoundingClientRect().top
            + window.scrollY
            - 118;

          window.scrollTo({
            top,
            behavior:'smooth'
          });

        }

      }

    }


    links.forEach(
      link => {

        link.addEventListener(
          'click',
          event => {

            event.preventDefault();

            showView(
              link.dataset.pnmdViewLink
            );

          }
        );

      }
    );


    root
      .querySelectorAll(
        '[data-pnmd-availability-cta]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            () => {

              showView(
                'availability'
              );

            }
          );

        }
      );


    const requested =
      window.location.hash
        .replace('#mentor-', '')
        .replace('#', '')
        .trim();


    showView(
      allowed.has(requested)
        ? requested
        : 'overview',
      false,
      false
    );


    syncRealData();


    const watched =
      root.querySelectorAll(
        [
          '[data-pnmd-sessions]',
          '[data-pnmd-rating]',
          '[data-pnmd-public-state]'
        ].join(',')
      );


    if (watched.length) {

      const observer =
        new MutationObserver(
          syncRealData
        );

      watched.forEach(
        node => {

          observer.observe(
            node,
            {
              childList:true,
              characterData:true,
              subtree:true
            }
          );

        }
      );

    }

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMentorWorkspaceSwitcher
    );

  }
  else {

    initMentorWorkspaceSwitcher();

  }

})();

/* MENTOR WORKSPACE SWITCHER END */



/* =========================================================
   PN_REAL_MENTOR_EARNINGS_V2
========================================================= */

(() => {

  function esc(value) {

    return String(
      value ?? ''
    )
      .replaceAll(
        '&',
        '&amp;'
      )
      .replaceAll(
        '<',
        '&lt;'
      )
      .replaceAll(
        '>',
        '&gt;'
      )
      .replaceAll(
        '"',
        '&quot;'
      )
      .replaceAll(
        "'",
        '&#039;'
      );

  }


  function money(
    amount,
    currency
  ) {

    const value =
      Number(
        amount || 0
      );


    const code =
      String(
        currency || 'INR'
      )
        .toUpperCase();


    try {

      return new Intl.NumberFormat(
        undefined,
        {
          style:'currency',
          currency:code,
          maximumFractionDigits:2
        }
      )
        .format(
          value
        );

    }
    catch (_) {

      return (
        code
        +
        ' '
        +
        value.toFixed(2)
      );

    }

  }


  function dateText(value) {

    if (!value) {
      return 'Date unavailable';
    }


    return new Date(
      value
    )
      .toLocaleString(
        [],
        {
          dateStyle:'medium',
          timeStyle:'short'
        }
      );

  }


  /* PN_DISABLE_LEGACY_MENTOR_EARNINGS_V1 */
  async function loadMentorPayments() {

    /*
     * Legacy gross-payment renderer disabled.
     *
     * Earnings are now owned by:
     * PN_MENTOR_EARNINGS_V1
     * -> rpc/get_my_mentor_earnings
     *
     * Keep this function as a no-op because older
     * dashboard listeners may still call it.
     */

    return;

  }


  document.addEventListener(
    'click',
    event => {

      if (
        !event.target.closest(
          '[data-pnmd-view-link="earnings"]'
        )
      ) {
        return;
      }


      setTimeout(
        () => {
          void loadMentorPayments();
        },
        0
      );

    }
  );


  window.addEventListener(
    'pageshow',
    () => {

      const earningsView =
        document.querySelector(
          '[data-pnmd-view="earnings"]'
        );


      if (
        earningsView &&
        !earningsView.hidden
      ) {

        void loadMentorPayments();

      }

    }
  );

})();



/* =========================================================
   PN_MENTOR_EARNINGS_V1
========================================================= */

(() => {

  function initMentorEarnings() {

    const root =
      document.querySelector(
        '[data-pnmd-earnings-root]'
      );


    if (
      !root ||
      root.dataset
        .pnMentorEarningsReady ===
          '1'
    ) {
      return;
    }


    root.dataset
      .pnMentorEarningsReady =
      '1';


    const list =
      root.querySelector(
        '[data-pnmd-earnings-list]'
      );


    const total =
      root.querySelector(
        '[data-pnmd-earnings-total]'
      );


    const pending =
      root.querySelector(
        '[data-pnmd-earnings-pending]'
      );


    const available =
      root.querySelector(
        '[data-pnmd-earnings-available]'
      );


    const paid =
      root.querySelector(
        '[data-pnmd-earnings-paid]'
      );


    function esc(value) {

      return String(
        value ?? ''
      )
        .replaceAll(
          '&',
          '&amp;'
        )
        .replaceAll(
          '<',
          '&lt;'
        )
        .replaceAll(
          '>',
          '&gt;'
        )
        .replaceAll(
          '"',
          '&quot;'
        )
        .replaceAll(
          "'",
          '&#039;'
        );

    }


    function money(
      value,
      currency = 'INR'
    ) {

      const number =
        Number(
          value || 0
        );


      try {

        return new Intl
          .NumberFormat(
            'en-IN',
            {
              style:
                'currency',

              currency:
                currency || 'INR',

              minimumFractionDigits:
                2,

              maximumFractionDigits:
                2
            }
          )
          .format(
            Number.isFinite(
              number
            )
              ? number
              : 0
          );

      }
      catch (_) {

        return `₹${
          (
            Number.isFinite(
              number
            )
              ? number
              : 0
          ).toFixed(2)
        }`;

      }

    }


    function dateText(value) {

      if (!value) {
        return '—';
      }


      const date =
        new Date(value);


      if (
        Number.isNaN(
          date.getTime()
        )
      ) {
        return '—';
      }


      return date.toLocaleString(
        'en-IN',
        {
          dateStyle:
            'medium',

          timeStyle:
            'short'
        }
      );

    }


    function statusLabel(
      status,
      bookingStatus
    ) {

      if (
        status === 'void'
      ) {

        if (
          bookingStatus ===
          'cancelled'
        ) {
          return 'Void · Session cancelled';
        }

        return 'Void · Not eligible for payout';

      }


      if (
        status === 'available'
      ) {
        return 'Available · Session completed';
      }


      if (
        status === 'paid'
      ) {
        return 'Paid · Payout settled';
      }


      if (
        status === 'pending'
      ) {

        if (
          bookingStatus ===
          'confirmed'
        ) {
          return 'Pending · Session not completed';
        }

        return 'Pending · Awaiting completion';

      }


      return (
        status ||
        'Unknown'
      );

    }


    function render(data) {

      const summary =
        data?.summary ||
        {};


      const currency =
        summary.currency ||
        'INR';


      if (total) {

        total.textContent =
          money(
            summary.total_earnings,
            currency
          );

      }


      if (pending) {

        pending.textContent =
          money(
            summary.pending,
            currency
          );

      }


      if (available) {

        available.textContent =
          money(
            summary.available,
            currency
          );

      }


      if (paid) {

        paid.textContent =
          money(
            summary.paid_out,
            currency
          );

      }


      const items =
        Array.isArray(
          data?.items
        )
          ? data.items
          : [];


      if (!items.length) {

        list.innerHTML = `
          <div class="pnmd-earnings-empty">

            <strong>
              No earnings yet
            </strong>

            <span>
              Paid mentoring sessions will
              appear here automatically.
            </span>

          </div>
        `;

        return;

      }


      list.innerHTML =
        items
          .map(
            item => {

              const status =
                item.status ||
                'pending';


              return `
                <article
                  class="
                    pnmd-earning-row
                  "
                  data-status="${esc(
                    status
                  )}"
                >

                  <div
                    class="
                      pnmd-earning-row__session
                    "
                  >

                    <strong>
                      ${esc(
                        item.student_name ||
                        'PeerNest Student'
                      )}
                    </strong>

                    <span>
                      ${esc(
                        dateText(
                          item.starts_at
                        )
                      )}
                    </span>

                  </div>


                  <div
                    class="
                      pnmd-earning-row__money
                    "
                  >

                    <small>
                      SESSION
                    </small>

                    <strong>
                      ${esc(
                        money(
                          item.gross_amount,
                          item.currency
                        )
                      )}
                    </strong>

                  </div>


                  <div
                    class="
                      pnmd-earning-row__money
                    "
                  >

                    <small>
                      YOUR 51%
                    </small>

                    <strong>
                      ${esc(
                        money(
                          item.mentor_amount,
                          item.currency
                        )
                      )}
                    </strong>

                  </div>


                  <div
                    class="
                      pnmd-earning-row__money
                    "
                  >

                    <small>
                      PEERNEST 49%
                    </small>

                    <strong>
                      ${esc(
                        money(
                          item.platform_amount,
                          item.currency
                        )
                      )}
                    </strong>

                  </div>


                  <div
                    class="
                      pnmd-earning-row__status
                    "
                  >

                    <span
                      class="
                        pnmd-earning-status
                      "
                      data-status="${esc(
                        status
                      )}"
                    >
                      ${esc(
                        statusLabel(
                          status,
                          item.booking_status
                        )
                      )}
                    </span>

                    ${
                      item.payout_reference
                        ? `
                          <small>
                            ${esc(
                              item.payout_reference
                            )}
                          </small>
                        `
                        : ''
                    }

                  </div>

                </article>
              `;

            }
          )
          .join('');

    }


    async function load() {

      if (
        !window.PeerNestDB
      ) {
        return;
      }


      if (list) {

        list.innerHTML = `
          <div
            class="
              pnmd-earnings-loading
            "
          >
            Loading earnings…
          </div>
        `;

      }


      try {

        const data =
          await window.PeerNestDB
            .request(
              'rpc/get_my_mentor_earnings',
              '',
              {
                method:
                  'POST',

                body:{}
              }
            );


        render(
          data || {}
        );

      }
      catch (error) {

        if (list) {

          list.innerHTML = `
            <div
              class="
                pnmd-earnings-empty
              "
            >

              <strong>
                Earnings unavailable
              </strong>

              <span>
                ${esc(
                  error?.message ||
                  'Could not load earnings.'
                )}
              </span>

            </div>
          `;

        }

      }

    }


    document.addEventListener(
      'click',
      event => {

        const button =
          event.target.closest(
            '[data-pnmd-view-link="earnings"]'
          );


        if (button) {
          load();
        }

      }
    );


    if (
      window.PeerNestDB
    ) {

      load();

    }
    else {

      document.addEventListener(
        'peernest:supabase-ready',
        load,
        {
          once:true
        }
      );

    }

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMentorEarnings,
      {
        once:true
      }
    );

  }
  else {

    initMentorEarnings();

  }

})();







